import { LoggingProvider } from '../providers/loggingProvider';

export const LOG_EVENT = 'LOG_EVENT';
export const LOG_EVENT_REJECTED = 'LOG_EVENT_REJECTED';
export const LOG_EVENT_FULFILLED = 'LOG_EVENT_FULFILLED';

export function logEvent(
    baseUrl,
    authId,
    secret,
    eventType,
    params,
    data,
    stdParameters
) {
    return {
        type: LOG_EVENT,
        payload: _logEvent(
            baseUrl,
            authId,
            secret,
            eventType,
            params,
            data,
            stdParameters
        )
    };
}

async function _logEvent(
    baseUrl,
    authId,
    secret,
    eventType,
    params,
    data,
    stdParameters
) {
    const op = new LoggingProvider(baseUrl, authId, secret);
    return await op.logEvent(eventType, params, data, stdParameters);
}
